/**
* RevisableLanguagePack.js
* 
* Created on 13-mei-2014, 15:08:43
*
* @author Ivo Swartjes for Ranj
**/

import LanguagePack from "./LanguagePack";


export default class RevisableLanguagePack {
    constructor() {
        this._defaultLanguagePack = new LanguagePack();
        this._revisedLanguagePack = new LanguagePack();

        this._useRevisions;
    }

    useRevisions(value) {
        if (this._useRevisions !== value) {
            this._useRevisions = value;
            this.dispatchEvent(RevisableLanguagePackEvent.USE_REVISIONS_CHANGED, value);
        }
    };

    isUsingRevisions() {
        return this._useRevisions;
    };

    setRevision(label, revisionValue, prefix) {
        this._revisedLanguagePack.setText(label, revisionValue, prefix);
    };

    getOriginalText(label, prefix, applyReplacements) {
        return this._defaultLanguagePack.getText(label, prefix, applyReplacements);
    };

    getRevisedText(label, prefix, applyReplacements) {
        return this._revisedLanguagePack.getText(label, prefix, applyReplacements);
    };

    getText(label, prefix, applyReplacements) {
        if (this._useRevisions) {
            var revisedText = this._revisedLanguagePack.getText(label, prefix, applyReplacements);
            if (!isNull(revisedText)) {
                return revisedText;
            } else {
                return this._defaultLanguagePack.getText(label, prefix, applyReplacements);
            }
        } else {
            return this._defaultLanguagePack.getText(label, prefix, applyReplacements);
        }
    };

    setText(label, value, prefix) {
        this._defaultLanguagePack.setText(label, value, prefix);
    };

    removeText(label, prefix) {
        this._defaultLanguagePack.removeText(label, prefix);
    };

    hasText(label, prefix) {
        return this._defaultLanguagePack.hasText(label, prefix);
    };

    getContent(label, type, prefix) {
        if (this._useRevisions) {
            var revisedText = this._revisedLanguagePack.getContent(label, type, prefix);
            if (!isNull(revisedText)) {
                return revisedText;
            } else {
                return this._defaultLanguagePack.getContent(label, type, prefix);
            }
        } else {
            return this._defaultLanguagePack.getContent(label, type, prefix);
        }
    };

    setContent(label, type, value, prefix) {
        this._defaultLanguagePack.setContent(label, type, value, prefix);
    };

    renameContent(label, newLabel, type, newType, prefix, newPrefix) {
        this._defaultLanguagePack.renameContent(label, newLabel, type, newType, prefix, newPrefix);
    };

    removeContent(label, type, prefix) {
        this._defaultLanguagePack.removeContent(label, type, prefix);
    };

    hasContent(label, type, prefix) {
        return this._defaultLanguagePack.hasContent(label, type, prefix);
    };

    getFullLabel(label, prefix) {
        return this._defaultLanguagePack.getFullLabel(label, prefix);
    };

    reset() {
        this._defaultLanguagePack.reset();
        this._revisedLanguagePack.reset();
    };

    merge(languagePack, overwrite) {
        this._defaultLanguagePack.merge(languagePack, overwrite);
    };

    addReplacement(textReplacement) {
        this._defaultLanguagePack.addReplacement(textReplacement);
        this._revisedLanguagePack.addReplacement(textReplacement);
    };

    removeReplacement(textReplacement) {
        this._defaultLanguagePack.removeReplacement(textReplacement);
        this._revisedLanguagePack.removeReplacement(textReplacement);
    };

    convertToObject() {
        return this._defaultLanguagePack.convertToObject();
    };

    setPropertiesFromObject(object) {
        this._defaultLanguagePack.setPropertiesFromObject(object);
    };

    /**
     * Use the default language pack as the event dispatcher     
     */

    addEventListener(type, listener, scope) {
        this._defaultLanguagePack.addEventListener(type, listener, scope);
    };

    removeEventListener(type, listener, scope) {
        this._defaultLanguagePack.removeEventListener(type, listener, scope);
    };

    dispatchEvent(type, data) {
        return this._defaultLanguagePack.dispatchEvent(type, data);
    };

    hasEventListener(type) {
        return this._defaultLanguagePack.hasEventListener(type);
    };

    hasSection(path) {
        return !!this._defaultLanguagePack.getNode(path, false);
    };

    getSection(path) {
        return this._defaultLanguagePack.getNode(path, false);
    };
}

export var RevisableLanguagePackEvent = {
    USE_REVISIONS_CHANGED: "RevisableLanguagePackEvent.USE_REVISIONS_CHANGED"
};

